var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCityLightRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 250,
    viewBox: "0 0 292 250",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BBBBC9",
    points: "871 2221.942 880.512 2136.891 889.873 2137.947 891.569 2122.805 908.843 2124.744 907.072 2140.603 913.629 2140.603 900.485 2258.088 910.569 2259.22 932.585 2062.455 944.825 2063.828 948.051 2035 950.93 2035.324 947.704 2064.153 946.657 2073.523 977.611 2076.994 963.103 2206.724 973.18 2207.856 980.521 2142.27 988.435 2143.153 993.085 2134.19 1020.919 2146.065 1023.452 2182.106 1017.882 2231.84 1020.761 2232.165 1023.829 2204.778 1033.928 2179.639 1040.727 2184.045 1062.411 2179.179 1065.923 2193.438 1061.408 2233.802 1068.606 2234.609 1077.07 2158.929 1082.836 2159.577 1083.401 2154.53 1124.44 2159.132 1124.034 2162.739 1127.862 2180.68 1120.438 2246.99 1157.882 2251.185 1157.234 2256.949 1163 2257.598 1160.498 2279.938 1088.489 2285 884.001 2262.079",
    transform: "translate(-871 -2035)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCityLightRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/city-light-right.ca32d58c.svg";
export { ForwardRef as ReactComponent };